module.exports = __webpack_public_path__ + "static/media/03B.104156b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/03B.png
// module id = 260
// module chunks = 0